import React from 'react';
import { PillarData } from '../../lib/pillarTypes';
import styles from './ProjectDetail.module.css';

export interface ExpertTabPanelProps {
  data: PillarData;
}

/* Placeholder article data */
const SAMPLE_ARTICLES = [
  {
    title: 'Best Practices in Urban Canopy Restoration',
    author: 'Dr. Sarah Chen',
    date: 'Feb 12, 2026',
    excerpt:
      'A review of evidence-based approaches to restoring urban tree canopy cover, including species selection, soil preparation, and community engagement strategies.',
  },
  {
    title: 'Measuring Environmental Impact: Beyond Tree Counts',
    author: 'Marcus Okonkwo',
    date: 'Jan 28, 2026',
    excerpt:
      'Why counting trees planted is only the beginning. This article explores survival rates, carbon sequestration metrics, and biodiversity indicators as complementary KPIs.',
  },
  {
    title: 'Volunteer Coordination at Scale',
    author: 'Lisa Park',
    date: 'Jan 15, 2026',
    excerpt:
      'Lessons learned from coordinating 200+ volunteers across three planting seasons. Covers scheduling, training, retention, and recognition strategies.',
  },
];

export default function ExpertTabPanel({ data }: ExpertTabPanelProps) {
  return (
    <div className={styles.panel}>
      <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
        Curated expert articles reviewed by content owners. Submission and editorial review
        ensure quality and trust.
      </p>

      <div className={styles.cardList}>
        {SAMPLE_ARTICLES.map((a, i) => (
          <div key={i} className={styles.articleCard}>
            <h4 className={styles.articleCardTitle}>{a.title}</h4>
            <div className={styles.articleCardMeta}>
              {a.author} &middot; {a.date}
            </div>
            <p className={styles.articleCardExcerpt}>{a.excerpt}</p>
          </div>
        ))}
      </div>

      <div className={styles.placeholder} style={{ marginTop: 20 }}>
        <div className={styles.placeholderIcon}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="1.5">
            <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
          </svg>
        </div>
        <h4 className={styles.placeholderTitle}>Submit an Article</h4>
        <p className={styles.placeholderText}>
          Expert contributors can submit educational articles for editorial review. Articles
          that pass review appear here as curated, trusted knowledge.
        </p>
      </div>
    </div>
  );
}
